'use strict';

module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web/lib/json-clone.js
// module id = 541
// module chunks = 1